import http from "../http-common";

class AMISERVICE {
  getAll() {
    return http.get("/trackRecordALL");
  }

  get(id) {
      return http.get(`/api/GetTrackdata?EtrackID=${id}`);
   //return http.get(`http://localhost:63914/api/GetTrackdata?EtrackID=${id}`);
  }

  create(data) {
    console.log("GetRecord Body",data)
    return http.post("/GetTrackRecord", data);
  }

  update(id, data) {
    return http.put(`/tutorials/${id}`, data);
  }

  delete(id) {
    return http.delete(`/tutorials/${id}`);
  }


}

export default new AMISERVICE();